


import {Component, Emit, Vue} from 'vue-property-decorator';
import Filter from '@/library/filter/filter.interface';
import {Observable, Subscriber, of} from 'rxjs';
import {map, catchError, mergeMap} from 'rxjs/operators';
import FilterOptionGroup from '@/components/map-filter-option-group/filter-option-group.interface';
import FilterOption from '@/components/map-filter-option-group/filter-option.interface';
import AppMapFilterOptionGroup from '@/components/map-filter-option-group/map-filter-option-group.vue';
import ApiService from '@/services/api.service';
import DeviceLocationService from '@/services/device-location.service';
import {Slugify} from '@/library/seo/slugify';
import {FiltersInRoute} from '@/library/route/filters-in-route';
import {FilterEqual} from '@/library/filter/filter-equal';
import {FilterNotEqual} from '@/library/filter/filter-not-equal';
import AnalyticsService from '@/services/analytics.service';
import MapService from '@/services/map.service';

@Component({})
export default class AppMapFilter extends Vue {

  @Emit('init')
  public emitInit(): Filter[][] {
    return this.selectedFilters();
  }

  @Emit('apply')
  public emitApply(): Filter[][] {
    return this.selectedFilters();
  }

  public initialised: boolean = false;
  public hasActiveFilters: boolean = false;
  public isExpanded: boolean = false;
  public userFilters: FilterOption[] = [
    {
      id: '1',
      name: 'nearby',
      value: true,
      label: 'Man tuvumā',
      type: 'checkbox',
      isSelected: false,
      includeInUrl: false,
      canSelect: this.canSelectNearMe,
      filter: (name, value) => new FilterEqual(name, value)
    },
    {
      id: '2',
      name: 'LIKE',
      value: 1,
      label: 'Man patīk',
      type: 'checkbox',
      isSelected: false,
      includeInUrl: false,
      canSelect: this.isAuthenticated,
      filter: (name, value) => new FilterEqual(name, value)
    },
    {
      id: '3',
      name: 'VISITED',
      value: 1,
      label: 'Esmu bijis',
      type: 'checkbox',
      includeInUrl: false,
      isSelected: false,
      canSelect: this.isAuthenticated,
      afterSelect: this.afterVisitedFilterChecked,
      filter: (name, value) => new FilterEqual(name, value)
    },
    {
      id: '4',
      name: 'VISITED',
      value: 0,
      label: 'Neesmu bijis',
      type: 'checkbox',
      isSelected: false,
      includeInUrl: false,
      canSelect: this.isAuthenticated,
      afterSelect: this.afterVisitedFilterChecked,
      filter: (name, value) => new FilterEqual(name, value)
    },
  ];

  public categoriesFilter: FilterOption[] = [
    {
      id: '10',
      name: 'PLACESUBTYPE',
      value: 7,
      label: 'populārākie galamērķi',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '11',
      name: 'PLACESUBTYPE',
      value: 5,
      label: 'dabas apskates objekts',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '12',
      name: 'PLACESUBTYPE',
      value: 3,
      label: 'dabas taka',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '13',
      name: 'PLACESUBTYPE',
      value: 9,
      label: 'skatu tornis',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '14',
      name: 'PLACESUBTYPE',
      value: 6,
      label: 'kultūrvēsturisks apskates objekts',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '15',
      name: 'PLACESUBTYPE',
      value: 2,
      label: 'atpūtas vieta',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '16',
      name: 'PLACESUBTYPE',
      value: 4,
      label: 'velotaka',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '17',
      name: 'PLACESUBTYPE',
      value: 11,
      label: 'ūdenstūristu atpūtas vieta',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '18',
      name: 'PLACESUBTYPE',
      value: [4, 10],
      label: 'aktīvā atpūta',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '19',
      name: 'PLACESUBTYPE',
      value: 40,
      label: 'maršruti iedvesmai',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    }
  ];

  public regionsFilter: FilterOption[] = [
    {
      id: '20',
      name: 'LVREGION',
      value: '3',
      label: 'Rīga un Pierīga',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '21',
      name: 'LVREGION',
      value: '1',
      label: 'Kurzeme',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '22',
      name: 'LVREGION',
      value: '2',
      label: 'Latgale',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '23',
      name: 'LVREGION',
      value: '4',
      label: 'Vidzeme',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '24',
      name: 'LVREGION',
      value: '5',
      label: 'Zemgale ',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    }
  ];

  public features: FilterOption[] = [
    {
      id: '31',
      name: 'TOURISMTYPESSTR',
      value: '28',
      label: 'bezmaksas vieta',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterNotEqual(name, value),
    },
    {
      id: '32',
      name: 'TOURISMTYPESSTR',
      value: '19',
      label: 'piemērots velobraucējiem',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '33',
      name: 'TOURISMTYPESSTR',
      value: '35',
      label: 'atļauts ar mājdzīvniekiem',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '34',
      name: 'TOURISMTYPESSTR',
      value: '25',
      label: 'pie ūdeņiem',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '35',
      name: 'TOURISMTYPESSTR',
      value: '4',
      label: 'ugunskura vieta',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '36',
      name: 'TOURISMTYPESSTR',
      value: '18',
      label: 'piemērots ar kustību traucējumiem',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '37',
      name: 'TOURISMTYPESSTR',
      value: '32',
      label: 'Latvijas Meža dēkainis',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
    {
      id: '38',
      name: 'TOURISMTYPESSTR',
      value: '8',
      label: 'putnu vērošana',
      type: 'checkbox',
      includeInUrl: true,
      isSelected: false,
      filter: (name, value) => new FilterEqual(name, value),
    },
  ];

  public groupsRef: AppMapFilterOptionGroup[] = [];
  public optionGroups: FilterOptionGroup[] = [
    {name: 'Tieši tev', filterOptions: this.userFilters, type: 'AND'},
    {name: 'Kategorijas', filterOptions: this.categoriesFilter, type: 'OR'},
    {name: 'Reģioni', filterOptions: this.regionsFilter, type: 'OR'},
    {name: 'Vietas pazīmes', filterOptions: this.features, type: 'AND'}
  ];

  private lastAppliedFilters: Filter[][] = [];
  private apiService: ApiService = ApiService.getInstance();
  private deviceLocationService: DeviceLocationService = DeviceLocationService.getInstance();
  private analyticsService: AnalyticsService = AnalyticsService.getInstance();
  private mapService: MapService = MapService.getInstance();

  constructor() {
    super();
  }

  public mounted(): void {
    this.groupsRef = this.$refs.groupsRef as AppMapFilterOptionGroup[];
  }

  public groupInitDone(): void {
    const initialisedGroups = this.groupsRef.filter((groupRef: AppMapFilterOptionGroup) => groupRef.initialised);
    if (initialisedGroups.length === this.optionGroups.length) {
      this.updateHasActiveFilters();
      this.emitInit();
    }
  }

  public expand(): void {
    this.isExpanded = true;
  }

  public collapse(): void {
    this.isExpanded = false;
  }

  public applyFilter(): void {
    this.updateHasActiveFilters();
    this.updateFiltersInRoute();
    this.toggleMapNearbyCircle();
    this.logToAnalytics();
    this.lastAppliedFilters = this.selectedFilters();
    this.collapse();
    this.emitApply();
  }

  public resetFilter(): void {
    this.groupsRef.forEach((groupRef: AppMapFilterOptionGroup) => groupRef.resetFilter());
    this.applyFilter();
  }

  public selectedFilters(): Filter[][] {
    return this.groupsRef
        .map((groupRef: AppMapFilterOptionGroup) => groupRef.selectedFilters())
        .filter((filters: Filter[][]) => filters.length > 0)
        .flat(1);
  }

  private isFilterAlreadyApplied(filter: Filter): boolean {
    return this.lastAppliedFilters.some((lastFilters: Filter[]) => {
      return lastFilters.some((lastFilter: Filter) => {
        return lastFilter.name === filter.name && lastFilter.value === filter.value;
      });
    });
  }

  private filterOptions(filter: Filter): FilterOption[] {
    return this.optionGroups
        .map((group: FilterOptionGroup) => {
          return group.filterOptions
              .filter((option: FilterOption) => option.name === filter.name && option.value === filter.value)
        })
        .flat(1);
  }

  private updateHasActiveFilters(): void {
    this.hasActiveFilters = this.selectedFilters().length > 0;
  }

  private updateFiltersInRoute(): void {
    const slugify = new Slugify();
    const filterSlugs: string[] = this.selectedFilters()
        .map((filters: Filter[]) => {
          return filters
              .map((filter: Filter) => this.filterOptions(filter)[0])
              .filter((filterOptions: FilterOption) => filterOptions.includeInUrl)
              .map((filterOption: FilterOption) => slugify.phrase(filterOption.label));
        })
        .flat(1);
    new FiltersInRoute().update(filterSlugs);
  }

  private isAuthenticated(): Observable<boolean> {
    if (!this.apiService.user().isAuthenticated) {
      alert('Lai veiktu šo darbību, ienāc vai reģistrējies!');
    }
    return new Observable((subscriber: Subscriber<boolean>) => {
      subscriber.next(this.apiService.user().isAuthenticated);
      subscriber.complete();
    });
  }

  private canSelectNearMe(filterOption: FilterOption): Observable<boolean> {
    return this.deviceLocationService.requestPermissions().pipe(
        catchError((error: Error) => {
          alert('Neizdodas iegūt atrašanās vietu!');
          return of(false);
        })
    );
  }

  private afterVisitedFilterChecked(filterOption: FilterOption): void {
    const idOfFilterToTurnOff = filterOption.id === '3' ? '4' : '3';
    const index = this.userFilters.findIndex(filter => filter.id === idOfFilterToTurnOff);
    this.userFilters[index].isSelected = false;
  }

  private toggleMapNearbyCircle(): void {
    const nearbyFilterSelected = this.selectedFilters().some((filters: Filter[]) => {
      return filters.some((filter: Filter) => filter.name === 'nearby');
    });
    this.mapService.toggleNearbyCircle(nearbyFilterSelected);
  }

  private logToAnalytics(): void {
    this.selectedFilters()
        .map((filters: Filter[]) => {
          return filters.filter((filter: Filter) => !this.isFilterAlreadyApplied(filter));
        })
        .flat(1)
        .map((filter: Filter) => {
          const isNot = filter instanceof FilterNotEqual;
          const filterName = filter.name.toLowerCase();
          const filterValue = filter.value.toString().toLowerCase();
          const filterId = isNot ? filterName + '_not_' + filterValue : filterName + '_' + filterValue;
          return this.analyticsService.logMapSelectFilter(filterId);
        })
  }
}
